import JSEncrypt from 'jsencrypt';
const LOGIN_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArPGS507G/qWW5Srm3P8E
2Wu0LeH2zNOccZtTVfd06KjcS4LBziFcoLm7Xg/xuxhpq2r3x9NgNGouMS2ECmls
oKviCxedAozfI3R1ss4nKU5DjzBnmCpwBG7991AbXfLsNNCEkw+GTj9B94aomA02
QTWtsLPRJOkCQUshsny/bwi2G4NjKf6pePClbrUVBJVYphStB2fvAZ8A3Yh2K2oZ
H9Q80/yyYmPTxUJhe1Cmv4dAuGfLh6ajzUCf15rp03X4mMEFNLXkHhdw0E7ht2aT
7kFdvJqy4nKm/isamqXRCUFap8m4nWyMc2AV96P32V3oRFHTKEE6Aw/8XzbcfdCo
IQIDAQAB
-----END PUBLIC KEY-----`;

export const encryptWithPublicKey = (content) => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(LOGIN_PUBLIC_KEY);
    const cipherText = encryptor.encrypt(String(content != null ? content : ''));
    if (!cipherText) {
        throw new Error('敏感信息加密失败');
    }
    return cipherText;
};



// WEBPACK FOOTER //
// ./src/components/common/rsa.js